/*  ---------------------------GENERIC HELPER FUNCTIONS ------------------------------- */

var breakpoints = {
	'xsmall': 319,
	'small': 576,
	'medium': 768,
	'large': 992,
	'xlarge': 1240,
	'xxlarge': 1440
  };

function breakpointClass() {
    var width = window.outerWidth;
    var $body = am.$('body');
    $body.removeClass('am-breakpoint-xsmall am-breakpoint-small am-breakpoint-medium am-breakpoint-large am-breakpoint-xlarge am-breakpoint-xxlarge');

	if(width <= breakpoints.xsmall){
		$body.addClass('am-breakpoint-xsmall');
	}
	else if(width > breakpoints.xsmall && width <= breakpoints.small){
		$body.addClass('am-breakpoint-small');
	}
	else if(width > breakpoints.small && width <= breakpoints.medium){
		$body.addClass('am-breakpoint-medium');
	}
	else if(width > breakpoints.medium && width <= breakpoints.large){
		$body.addClass('am-breakpoint-large');
	}
	else if(width > breakpoints.large && width <= breakpoints.xlarge){
		$body.addClass('am-breakpoint-xlarge');
	}
	else{
		$body.addClass('am-breakpoint-xxlarge');
	}
}

function checkBreakpointSize(){
	const $body = am.$('body');
	var window = '';

	if($body.hasClass('am-breakpoint-xlarge') || $body.hasClass('am-breakpoint-xxlarge'))
		window = 'desktop';
	else
		window = 'mobile';

	return window;
}

function loadLazyImage(id){
	var image = document.getElementById(id);
	if(!image.hasClassName("lazyLoad")){
		var imgDataSrcPath = image.getAttribute('data-src');
		fadeout(image);
		image.src = imgDataSrcPath;
		fadein(image);
		image.addClassName("lazyLoad");
	}	
}

function lazyloadBackgroundImages(){
	var loadImage = false;
	am.$(".lazyBackground").each(function( index ) {
		const $imageContainer = am.$(this);
		if($imageContainer.hasClass('js_lzbackgroundloaded')){
			//image is already loaded
		}
		else{
			if($imageContainer.data('loadclass')){
				var validClass = $imageContainer.data('loadclass').split(',');
				am.$.each(validClass, function( x, v ) {
					if(am.$("body").hasClass(v)){
						loadImage = true;
					}
				});
			}
			else{
				loadImage = true;
			}

			if (loadImage) {
				const isSelect = $imageContainer.parent('.pao_td')?.find('select')?.length > 0;

				if ($imageContainer.parent('.pao_td').length > 0 && isSelect && typeof get_product_image === 'function') {//for product attributes (orders.js, page-bundled since DEV-12923 - same guard as products.js refreshProductImageFor)
					get_product_image($imageContainer);
				} else {//for other images
					$imageContainer.css('background-image', 'url("' + $imageContainer.data('src') + '")');
				}
				$imageContainer.addClass('js_lzbackgroundloaded');
			}
		}
	});
}
function count(ob){ var ret = 0; for(var a in ob){ ret++; }; return ret; }
// the login fieldset within the new contact form uses this
function destroyElement(effect){
	effect.element.remove();
}
function delRow(block, specific=false) {
	let designated = block.up();
	if(specific){
		specific = block.getAttribute('data-specific');
		designated = block.up(specific);
	}
	
	Effect.BlindUp(designated, {
		duration:    0.4,
		afterFinish: destroyElement
	});
	return false;
}
function delTableRow(block) {
	block.up('tr').remove();
	return false;
}
function add_notification(message, notification_type){
	var autoclose = true;
	if(notification_type == 'error' || notification_type == 'danger'){
		notification_type = 'danger';
		autoclose = false;
	}
	show_snackbar({
		message: message,
		type: notification_type,
		show_close: true,
		timer: 4000,
		autoClose: autoclose
	}); 
}
function add_temp_notification(message, type) {
	var autoclose = true;
	var timer  = 5000;
	if(type == 'error' || type == 'danger'){
		type = 'danger';
		autoclose = false;
		timer = 0;
	}
	if(type == 'notice' || type == 'warning'){
		type = 'warning';
		autoclose = true;
		timer = 10000;
	}

	show_snackbar({
		message: message,
		type: type,
		show_close: true,
		autoClose: autoclose,
		timer: timer
	}); 
}

function get_employee_side_order_edit_confirm_text(){
	var r = "A payment has been made on this order. Editing the order now will likely result in issues with the invoice total. If the price on this order increases due to edits, you'll need to collect the rest of the payment. If the price decreases, you'll have to issue a credit memo."
	return r;
}
//give it a number like 123.32123 and it will give you $123.32123
function CurrencyFormatted(amount) {
	try{
		if(amount){
			var amount = (amount + '').replace(get_currency_symbol(), '');
			var num = amount.toString().replace(/\$|\,/g,'');
			var negsymbol = num.substring(0,1);
			if(isNaN(num)) {
				return get_currency_symbol() + "0.00";
			}
			var sign = (num == Math.abs(num));
			var num_parts = num.toString().split('.',2);
			var wh = num_parts[0];
			if (negsymbol == '-') {
				wh = wh.substring(1);
			}
			var cents = num_parts.length > 1 ? num_parts[1] : '00';
			for (var i = 0; i < Math.floor((wh.length - (1 + i)) / 3); i++) {
				wh = wh.substring(0, wh.length - (4 * i + 3)) + ',' + wh.substring(wh.length - (4 * i + 3));
			}
			if (negsymbol == '-') {
				wh = '-' + wh;
			}
			return (((get_currency_symbol())?'':'-') + get_currency_symbol() + wh + '.' + cents);
		}
		else{
			return get_currency_symbol()+"-";
		}
	}
	catch(err){
		return get_currency_symbol()+"-";
	}
}
var theForm;
function submit_post(url, data) {
	theForm = new Element('form',{'method':'post','action':url});
	$H(data).each(function(pair) {
		var val = new Element('input',{'name':pair.key,'value':pair.value});
		theForm.insert({'bottom':val});
	});
	$('page').insert({'after':theForm});
	theForm.submit();
	theForm.remove();
}

function preventDoubleNoteSubmit($this){
	var clickedval = am.$('#modal_submit').data('clicked');
	if(clickedval.length == 0){
		am.$('#modal_submit').data('clicked', 1);
		return MoxForm.Go($this, noAjax);
	}
}

/**
 * Prevents double/triple clicks on report filter submit buttons,
 * PDF export links, and CSV export links.
 * Full-page reload naturally resets all state.
 */
function initReportDoubleClickPrevention() {
	// --- Report submit buttons ---
	am.$('.filter button.am-btn--filled[type="submit"]').each(function() {
		var btn = this;
		var $btn = am.$(btn);

		btn.addEventListener('click', function(e) {
			if ($btn.data('submitting')) {
				e.preventDefault();
				e.stopImmediatePropagation();
				return false;
			}
			$btn.data('submitting', true);
			setTimeout(function() {
				$btn.prop('disabled', true);
				$btn.css('opacity', '0.6');
				show_loading_svg();
			}, 0);

			// Safety reset after 30s for validation failures or edge cases
			setTimeout(function() {
				$btn.data('submitting', false);
				$btn.prop('disabled', false);
				$btn.css('opacity', '');
				hide_loading_svg();
			}, 30000);
		}, true); // capture phase — fires before inline onclick
	});

	// --- Re-enable button on MoxForm validation failure ---
	if (typeof MoxForm !== 'undefined' && MoxForm.Go) {
		var _originalMoxFormGo = MoxForm.Go;
		MoxForm.Go = function() {
			var result = _originalMoxFormGo.apply(this, arguments);
			var ob = arguments[0];
			var formEl = am.$(ob).closest('form')[0];
			if (formEl && formEl.mox && formEl.mox.failed) {
				var $btn = am.$(formEl).find('button.am-btn--filled[type="submit"]');
				$btn.data('submitting', false);
				$btn.prop('disabled', false);
				$btn.css('opacity', '');
				hide_loading_svg();
			}
			return result;
		};
	}

	// --- PDF export links ---
	am.$('.am-sendto-row--pdf a').each(function() {
		var link = this;
		var $link = am.$(link);

		link.addEventListener('click', function(e) {
			if ($link.data('exporting')) {
				e.preventDefault();
				e.stopImmediatePropagation();
				return false;
			}
			$link.data('exporting', true);
			setTimeout(function() {
				$link.css({ opacity: '0.6', 'pointer-events': 'none' });
				show_loading_svg();
			}, 0);

			setTimeout(function() {
				$link.data('exporting', false);
				$link.css({ opacity: '', 'pointer-events': '' });
				hide_loading_svg();
			}, 10000);
		}, true);
	});

	// --- CSV export links ---
	am.$('.am-sendto-row--csv a').each(function() {
		var link = this;
		var $link = am.$(link);

		link.addEventListener('click', function(e) {
			if ($link.data('exporting')) {
				e.preventDefault();
				e.stopImmediatePropagation();
				return false;
			}
			$link.data('exporting', true);
			setTimeout(function() {
				$link.css('opacity', '0.6');
			}, 0);

			setTimeout(function() {
				$link.data('exporting', false);
				$link.css('opacity', '');
			}, 5000);
		}, true);
	});
}

am.$(document).ready(function() {
	initReportDoubleClickPrevention();
});

/*
A simple class I wrote for easily handling cookies.  Inspired by http://www.quirksmode.org/js/cookies.html#script
usage is simple:
Cookie.create('name', 'ryan', 7);  //-->creates a cookie named 'name' with the value 'ryan' and store it for 7 days.
Cookie.read('name');  //-->returns 'ryan'
Cookie.erase('name')  //removes the cookie named 'name'
*/
var Cookie = {
	create: function(name,value,days) {
		if (days) {
			var date = new Date();
			date.setTime(date.getTime()+(days*24*60*60*1000));
			var expires = "; expires="+date.toUTCString();
		}
		else var expires = "";
		document.cookie = name+"="+value+expires+"; path=/";
	},

	read: function(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	},
	erase: function(name) {
		this.create(name,"",-1);
	}
};

function _timing(fn, reps){
	reps = reps || 1000;
	var a = (new Date())-0;
	for(var i = 0; i < reps; i++){
		fn();
	}
	var b = (new Date())-0;
	return b-a;
}

// Collect text from child text nodes into a single string.
function get_textnode_text(el)
{
	var text = '';
	// We are making the assumption that there is only one meaningful text node (others are "empty") and that we don't care about excess whitespaces
	for(var i = 0; i < el.childNodes.length; i++)
	{
		if(el.childNodes[i].nodeName === '#text')
			text += el.childNodes[i].textContent.trim();
	}
	return text;
}

// Remove all non-selected OPTIONs from a SELECT element; simple way to prevent option from being changeable without setting the DISABLED attribute (since READONLY is not a valid attribute)
function isolate_selected_option(select_element)
{
	select_element.childElements().each(function(option)
	{
		if(option.getAttribute('selected') === null)
			option.remove();
	});
}



function is_touch_enabled() {
    return ( 'ontouchstart' in window ) ||
           ( navigator.maxTouchPoints > 0 ) ||
           ( navigator.msMaxTouchPoints > 0 );
}

function responsive_helper_element() {
    return document.querySelector('#responsive-helper');
}

function is_mobile_or_tablet() {
    return is_mobile() || is_tablet();
}

function is_mobile() {
    const element = responsive_helper_element();
    const display = element.getStyle('display');
    const content = element.getStyle('content');

    return display === 'block' && content === '"mobile"';
}

function is_tablet() {
    const element = responsive_helper_element();
    const display = element.getStyle('display');
    const content = element.getStyle('content');

    return display === 'block' && content === '"tablet"';
}

function show_options(obj){
	// Creates mobile options list passed functions and identifiers - with clickout overlay
	// EXAMPLE - show_options( JSON.stringify({ items: [ { text: "", icon: '<i class="fa-solid fa-pencil"></i>', callback: { event_listener: 'onclick', func:  'edit_card('+id+')' } } ] }) )
	const options = am.$('<div class="card-options-container"></div>');
	obj.items.forEach(function(item){
		if(item.modal){ // Currently set up as Delete confirmation
			var modal_options = JSON.stringify({
				targets: { target: '#modal_confirm_delete', modalid: 'modal_confirm_delete' },
				header: { navigation: { custom_html: '' }, title: false },
				content: { main: build_confirm_content(item.modal_msg, '"') },
				buttons: { custom_btns: true, count: 2, custom_modal_btns_class: 'am-custom-btns--modal',
					btns: [ { outline: true, color: 'blue', btn: 'Cancel', cb: 'data-bs-dismiss' }, { btn: 'Delete', cb: item.callback.func, color: 'red' } ],
				},
				size: 'modal-md'
			})
			// DEV-12308 (M3 2.1): canon menu item anatomy; modal items are delete
			// confirmations, so they take the danger treatment. .am-option stays as hook.
			var option = am.$(`<button type='button' class='am-menu__item am-menu__item--danger am-option btn' data-is_new='${item.is_new ? true : false}' data-toggle='modal' onclick='remove_options_list(); show_confirm_modal(${modal_options});'
			>${item.icon}<span>${item.text}</span></button>`)

		}else{
			var option = am.$(`<div class="am-menu__item am-option" data-is_new="${item.is_new ? true : false}" ${item.callback.event_listener}="${item.callback.func}">${item.icon}<span>${item.text}</span></div>`)
		}
		options.append(option)
	})

	var $html = am.$(`<div id="options-dialogbox" class="dialogbox box-options box-options-${obj.items.length}"><div class="dialogboxbody"></div></div>`);
	const $body = am.$('body');
	const modalOverlay = am.$(`<div id="am-optionsModalOverlay" class="am-modalOverlay" onclick="remove_options_list()"></div>`).css({'height':'1000%', 'width':'100vw'});
	$body.append(modalOverlay).append($html)
	$body.children('#options-dialogbox').children('.dialogboxbody').append(options);

	ensureGSAP().then(function(){
		const tl = gsap.timeline({ duration: .2 })
		tl.fromTo($html, { bottom: '-5rem'}, { bottom: '5rem'})
	});
}

function remove_options_list(){
	const $overlay = am.$('#am-optionsModalOverlay')
	const $optionsContainer =  am.$('#options-dialogbox')

	ensureGSAP().then(function(){
		const tl = gsap.timeline({ defaults: {duration: .30}, onComplete:function(){
			$optionsContainer.remove();
			$overlay.remove();
		}})
			tl
			.to($optionsContainer, {opacity: 0}, 'start')
			.to($overlay, {opacity: 0}, 'ease', 'start')
	});
}

function annimate_remove_card($card){
	ensureGSAP().then(function(){
		const tl = gsap.timeline({ defaults: {duration: .30}, onComplete: function(){
			$card.remove();
		}})
			tl
			.to($card, {opacity: 0, width: 0, height: 0}, 'ease')
	});
}

function append_hidden_overlay() {
	var height = am.$('#page_wrapper_responsive').height(); // Sets overlay height based on window size 
	var hidden_overlay = am.$(`<div id="hidden_overlay" style="height: ${height}px;" class="am-hidden-overlay"></div>`);
	am.$('body').append(hidden_overlay);
}

function get_std_msg_obj(){
	var msg_obj = {
		msg_delete: {
			success: get_language_translation('LANG_TEXT_CHANGES_SAVED_SUCCESSFULLY'),
			fail: get_language_translation('LANG_SOMETHING_WENT_WRONG_PLZ_TRY_AGAIN')
		},
		msg_update: {
			fail: get_language_translation('LANG_SOMETHING_WENT_WRONG_PLZ_TRY_AGAIN')
		}
	};

	return msg_obj;
}

function update_add_btn_state(t, disabled = false){
	am.$(t).prop('disabled', disabled)
}

function toggle_tooltip({target, msg, timer = 1000, ...options}){
	const tooltip = bootstrap.Tooltip.getInstance(target);

	tooltip.setContent( {
		'.tooltip-inner': msg ? msg : get_language_translation('LANG_TOOLTIP_COPIED')
	} );
	tooltip.show();

	setTimeout(function() {
		tooltip.hide();

		if(options.reset_msg)
			tooltip.setContent( { '.tooltip-inner': options.reset_msg } );

	}, timer);
}

function enforce_id_usage(){ // adding to component builders to enfoce id usage to assit with appcues
	const $require = am.$('.id_required');
	$require.each((i,el) => { console.log('DEV: Please add ID here', el); })
}

function update_translations_vars(){
	var translations = am.$('.js-var-in-translation');
	if(translations.length > 0){
		translations.each((i, el) => {
			const $this = am.$(el);
			let value = $this.html();
			
			let varIndex = 2; // Start from 2 for additional numbered attributes to handle more than 2 variables
			let varAttr = 'data-replace_var';
			let valueAttr = 'data-replace_value';
			
			if($this.attr(varAttr) && $this.attr(valueAttr)) {
				value = value.replace($this.attr(varAttr), $this.attr(valueAttr));
			}
			
			while($this.attr(varAttr + varIndex) && $this.attr(valueAttr + varIndex)) {
				value = value.replace($this.attr(varAttr + varIndex), $this.attr(valueAttr + varIndex));
				varIndex++;
			}
			
			$this.html(value);
		})
	}
}

function show_required(){
	var js_required = am.$('.js-required');
	if(js_required.length > 0){	
		js_required.each((i, el) => {
			const $this = am.$(el);
			if($this.length == 0) return;
			var time_tracking_id_arr = ['track_date', 'employee', 'contact_id', 'track_order', 'track_order_id', 'order_status', 'process', 'processModal', 'track_hours'];
			var $row = $this.parent('.am-section-row');
			if($row.length == 0){
				if(time_tracking_id_arr.includes($this.attr('id')))
					var $row = $this.parent().closest('.input');
				else
					var $row = $this.parent().closest('.am-section-row');
			}

			var $label = $row.children('.am-section-label');

			if($label.length == 0)
				var $label = $row.parent().closest('.am-section-row').children('.am-section-label');

			if($label.children('.req-astr').length == 0){
				if($label.children().length > 0)
					am.$('<span class="req-astr" style="padding-right: 5px;" >*</span>').insertBefore($label.children()[0]);
				else
					$label.append('<span class="req-astr">*</span>');
			}

			if($this.prop('tagName') == 'TD' && $this.children('.req-astr'))
				$this.append('<span class="req-astr">*</span>')
		})
	}
	// works with old designs but will take culling over forms to look for ** 
	var required = am.$('.required');	
	if(required.length > 0){
		required.each((i, el) => {
			const $this = am.$(el);
			var $label = $this.siblings('label');	

			if($label.length == 0)
				var $label = $this.parent().siblings('label');	

			if($label.children('span').length == 0)
				$label.append('<span class="req-astr">*</span>');

			if($this.prop('tagName') == 'TH' && $this.children('.req-astr').length == 0)
				$this.append('<span class="req-astr">*</span>');
		})
	}
}

function update_translations_vars(){
	var translations = am.$('.js-var-in-translation');
	if(translations.length > 0){
		translations.each((i, el) => {
			const $this = am.$(el);
			let value = $this.html().replace($this.attr('data-replace_var'), $this.attr('data-replace_value') )
			$this.html(value);
		})
	}
}

function getRowIfEmpty(dynamicElement) {
	if(dynamicElement.parent().hasClass('iti--allow-dropdown')) {
		return dynamicElement.parent().parent();
	}
}
function show_error_msg({ target, msg = get_language_translation('REQUIRED_FIELD_LANG'), custom_section = false }){
	// Target - id/class of the input that requires a value, 
	// msg - is the error message to display, 
	// custom_section is an object with the following structure: { section_type: 'unique-conditional-identifier', subsection: '.target-class' }
	const $el = am.$(target);
	if($el.hasClass('js-validate-cc-number'))
		var $row = $el.parent().closest('.am-section-row');
	else
		var $row = $el.parent('.am-section-row');

	if ($row.length == 0)
		var $row = $el.closest('.am-section-row');

	let $label = $row.children('.am-section-label');
	if($label.length == 0)
		$label = $row.find('.am-section-label');
	const $err_msg = $row.children('.error-msg');
	$el.addClass('am-error-border')
	$label.addClass('am-error-text')
	if(custom_section && typeof custom_section == 'object'){
		if(custom_section.section_type = 'card_expiration_date'){
			if(custom_section.subsection)
				var $elms = am.$(custom_section.subsection);
			else
				var $elms = $el.children('input');
			var error_lable_id = 'am-exp-date-cont-err-label';

			$elms.on('focus', (e) => {
				remove_error_classes($label, $el);
				am.$('#am-exp-date-cont-err-label').remove();
			});
		}
	}else{
		var error_lable_id = `${target.replace('#', '')}_err_label`;
	
		var onEvent = 'blur';
		if(options.clearOnKeyDown)
			onEvent = 'keydown';
		else if(options.clearOnClick)
			onEvent = 'click';
		
		$el.on(onEvent, () => {
			$label.removeClass('am-error-text');
			$el.removeClass('am-error-border');
			am.$('#' + error_lable_id).remove();
		});
	}
	if($err_msg .length == 0)
		$row.append(`<label id="${error_lable_id}" class="error-msg"><i class="fas fa-exclamation-triangle" style="margin-right: 5px;"></i><span class="msg">${msg}</span></label>`);
	else if(msg != $err_msg .children('.msg').text())
		$err_msg.children('.msg').text(msg);
}

function remove_error_classes($label, $el){
	$label.removeClass('am-error-text');
	$el.removeClass('am-error-border');

	if($el.hasClass('js-required_from_tether')) // This resets tethered inputs js-required class per each submit event
		$el.removeClass('js-required js-required_from_tether');
}


function iteriate_errors(failed_list){
	failed_list.each( (obj) => {
		show_error_msg({target: obj.target, msg: obj.msg, custom_section: obj.custom_section ? obj.custom_section : false});
	})
}

function check_remove_catalog_access(){
	const $rca = am.$('#remove_catalog_access');
	
	if($rca.length > 0){
		var elms = am.$('.js-remove_catalog_access').not('.js-remove_catalog_access-enabled');

		if(elms.length > 0){
			elms.each((i, el) => {
				const $this = am.$(el);
				$this.addClass('js-remove_catalog_access-enabled')
				if($this.is('input')){
					if($this.attr('type') == 'text' || $this.attr('type') == 'number'){
						$this.prop('readonly', 'readonly');
					}
					else if($this.attr('type') == 'checkbox' || $this.attr('type') == 'radio'){
						$this.prop('disabled', true);
					}
					else if($this.attr('type') == 'file' ){
						const $file_label = $this.parent().closest('.file');
						$file_label.addClass('js-remove_catalog_access')
					}
				}
				else if($this.is('select')){
					$this.on('mousedown', function(e) {
						const $this = am.$(this);
						$this.focus();
						var opts = $this.find('option');
						opts.each((i, el) => {
							am.$(el).prop('disabled', true);
						})
					});
				}
				else if($this.is('textarea')){
					$this.prop('readonly', 'readonly');
				}
				else if($this.is('div')){
					$this.find('a, button').each((i, el) => {
						const $el = am.$(el);
						if ($el.is('a') || $el.is('button')) {
							$this.css('pointer-events', 'none');
							$el.addClass('am-btn--disabled')
                    	}
                	});
				}
				else if($this.is('a')){
					if($this.hasClass('delete_link') || $this.hasClass('add_row') || $this.hasClass('am-btn--text') || $this.hasClass('js-remove_catalog_access')){
						$this.css('pointer-events', 'none');
						if(!$this.hasClass('am-btn--disabled'))
							$this.addClass('am-btn--disabled');
					}
				}else if($this.is('button')){
					$this.css('pointer-events', 'none').addClass('disabled').removeClass('blue');
					if($this.hasClass('am-btn--outlined') && !$this.hasClass('am-btn--disabled'))
						$this.addClass('am-btn--disabled');
					else if($this.hasClass('am-btn') && !$this.hasClass('am-btn--disabled'))
						$this.addClass('am-btn--disabled');
				}
				else if($this.is('label') && ($this.hasClass('switch') || $this.hasClass('am-switch') || $this.hasClass('am-checkbox'))){
					const $input = $this.find('input');
					$input.prop('disabled', true)
				}
			})
		}
	}
}

// (A dead duplicate of the masked-eye toggle lived here for years — its selector
// '.js-masked .js-unmasked' was a descendant combinator that could never match.
// Removed in DEV-12536; the live delegated handler is below at '.js-masked, .js-unmasked'.)

function show_loading_svg() {
	const $loading = am.$('#loading');

	if ($loading.length > 0) {
		$loading.show().children('.circularLoading').css({
			position: 'fixed',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)',
			margin: 0
		});
	}
}

function hide_loading_svg(){
	const $loading = am.$('#loading');
	if ($loading.length > 0) {
		$loading.hide();
	}
}

// Show loading spinner immediately on navigation link click so the user sees feedback while the page loads
// DEV-12588: this handler had no modifier-key guard, so cmd/ctrl/shift-clicking an
// order into a new tab — where you stay on this page — raised the full-viewport
// #loading overlay and the 2500ms timer then held it there, swallowing every click
// until it expired. Users could no longer open several orders in a row. The guards
// below mirror the ones site.js's ajld handler already had; the overlay itself is now
// pointer-events: none (modulev1/_styles.scss) so it can never eat a click again.
// The overlay must keep being raised from here: hide_loading_svg() leaves an inline
// display:none behind, so after any ajax completes (the livetable fetch on every list
// page) the .ajld class rule can no longer show it, and this is the only path left.
var _navLoadingTimeout;
am.$(document).on('click', 'a[href]', function (e) {
	var a = e.currentTarget;
	if (!a || !a.href) return;
	if (e.isDefaultPrevented()) return;
	// A modifier click opens elsewhere (new tab/window/download) and leaves the user
	// on this page, so there is no page load here to give feedback about.
	if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
	if (a.target === '_blank' || a.getAttribute('target') === '_blank') return;
	var hrefAttr = (a.getAttribute('href') || '').trim();
	if (hrefAttr === '#' || hrefAttr.indexOf('#') === 0) return;
	if (/^\s*javascript:/i.test(a.getAttribute('href') || '')) return;
	// Don't show for modal links (they prevent default and open in modal)
	if (a.onclick && (a.getAttribute('onclick') || '').indexOf('open_modal') !== -1) return;
	try {
		var url = new URL(a.href, window.location.origin);
		if (url.origin !== window.location.origin) return;
	} catch (err) { return; }
	if (_navLoadingTimeout) clearTimeout(_navLoadingTimeout);
	show_loading_svg();
	_navLoadingTimeout = setTimeout(function () { hide_loading_svg(); _navLoadingTimeout = null; }, 2500);
});

function simulated_click(href, blank=false){ // works with moving links to confirm modals
	var target = '';
	if(blank)
		target = ' target="_blank" ';

	am.$('body').append(`<a href="${href}" ${target} id="simulated_click_link"></a>`);
	setTimeout(() => { 
		am.$('#simulated_click_link').get(0).click(); 
	}, 500);
}

am.$(document).on('click', '.js-masked, .js-unmasked', (e) => {
	const $eye = am.$(e.target);
	const $inp = $eye.siblings('.am-section-input');

	if($eye.hasClass('js-masked')){
		$eye.addClass('js-unmasked').removeClass('js-masked');
		$inp.prop('type', 'text');

	}else{
		$eye.addClass('js-masked').removeClass('js-unmasked');
		$inp.prop('type', 'password')
	}

	if($eye.hasClass('unmask-copy')){
		const $copy = $eye.siblings('.am-section-label').children('.fa-clone');
		$copy.toggleClass('hide');
		copy_text($copy, $inp);
	}
})

function copy_textarea(e){
	const $copy = am.$(e.target);
	const $textarea = $copy.siblings('.am-textarea');
	copy_text($copy, $textarea)
}

function copy_text($copy_icon, $inp){
	$copy_icon.on('click', (e) => {
		var textField = document.createElement('textarea');
		textField.innerText = $inp.val();
		document.body.appendChild(textField);
		textField.select();
		textField.focus(); //SET FOCUS on the TEXTFIELD IMPORTANT FOR BS-MODAL
		document.execCommand('copy');
		textField.remove();
	
		toggle_tooltip({
			target: '#'+e.target.id, 
			reset_msg: get_language_translation('LANG_COPY')
		});
	})
}

function allow_numbers_only(e){ // backspace || tab || arrow keys accepted || .
	var charCode = (e.which) ? e.which : e.keyCode
	if (( charCode >= 48 && charCode <= 57 && !e.shiftKey ) || charCode == 8 || charCode == 9 || charCode == 37 || charCode == 39 || charCode == 190){
		return true; // Allow the key
	}
	else {
		e.preventDefault(); // Prevent the key
		return false;
	}
}

function activate_options_menu(){
	// DEV-12308 (M3 2.1): menus open by toggling canon .is-open on the .am-menu-anchor
	// wrapper (m3/_menu.scss owns surface + animation). Same triggers as before:
	// click opens, mouseleave closes.
	var menus = am.$('.am-option-menu');
	menus.each((i, menu) => {
		const $menu = am.$(menu);
		$menu.on('click', () => {
			const $td = $menu.parent('td');
			if($td.length > 0)
				$menu.css( { zIndex: 5 } );

			if($menu.is(':visible')){
				$menu.addClass('is-open');

				$menu.on('mouseleave', () => {
					$menu.removeClass('is-open');
					$menu.css( { zIndex: 1 } );
				})
			}
			else{
				$menu.removeClass('is-open');
			}
		})
	})
}

function checkBoxValueUpdated(e) {
    const $this = am.$(e.target);
    const target_id = $this.attr('data-target_id');
	const $hidden_input = am.$(`#${target_id}`);
	const $toggle = am.$(`#${target_id}_toggle`)
	const $yes = am.$(`#${target_id}_yes`);
	const $no = am.$(`#${target_id}_no`);

    if($hidden_input.val() == 0){
		$yes.prop('checked', true);
		$no.prop('checked', false);
		$toggle.prop('checked', true);
		$hidden_input.val(1);
	}
	else{
		$yes.prop('checked', false);
		$no.prop('checked', true);
		$toggle.prop('checked', false);
		$hidden_input.val(0);
	}

	if($hidden_input.length > 0 && $hidden_input.hasClass('js-trigger-onchange'))
		$hidden_input.trigger('change');
    
    e.stopPropagation();
}

function generateUniqueId() {
    const date = new Date();
    const uniqueId = date.getFullYear() + (date.getMonth() + 1).toString().padStart(2, '0') +date.getDate().toString().padStart(2, '0') + date.getHours().toString().padStart(2, '0') + date.getMinutes().toString().padStart(2, '0') + date.getSeconds().toString().padStart(2, '0') + date.getMilliseconds().toString().padStart(3, '0');
    return uniqueId;
}

function object_to_array(obj){
	const arr = Object.keys(obj).map((key) => ({key, value: obj[key]}));
	return arr;
}

function del_phone(t){
	const $this = am.$(t);
	const $section = $this.parent().closest('.phone-number-component')

	if($section.length > 0)
		$section.remove();
}

function allow_numbers_only(e){
	var charCode = (e.which) ? e.which : e.keyCode
	if (
		( charCode >= 33 && charCode <= 37) || // page up/down, end, home, left arrow, 
		( charCode >= 48 && charCode <= 57 && !e.shiftKey ) || // 0-9 std
		( charCode >= 96 && charCode <= 105 && !e.shiftKey ) || // 0-9 keypad
		charCode == 8 || charCode == 9 || charCode == 39 || charCode == 46 || charCode == 190 // backspace, tab, right arrow, delete, .
	){
		return true; // Allow the key
	}
	else {
		e.preventDefault(); // Prevent the key
		return false;
	}
}
function scroll_to_inline_snackbar(targetClass, cb = false){
	var $inline_snacks = am.$('.'+targetClass + ' .am-alert');
	if (!$inline_snacks.length) return;
	$inline_snacks.parent().parent().get(0).scrollIntoView({behavior: 'smooth', block: 'start'});
}


function allow_numbers_only(e){ // backspace || tab || arrow keys accepted
	var charCode = (e.which) ? e.which : e.keyCode
	if (( charCode >= 48 && charCode <= 57 && !e.shiftKey ) || charCode == 8 || charCode == 9 || charCode == 37 || charCode == 39 ){
		return true; // Allow the key
	}
	else {
		e.preventDefault(); // Prevent the key
		return false;
	}
}

function inactivity_check(cb, idleLimit=600000, idleTime=0){ // idleLimit=10min 
    function resetTimer() {
        clearTimeout(idleTime);
        idleTime = setTimeout(cb, idleLimit);
    }

    const events = ['mousemove', 'mousedown', 'keypress', 'touchstart', 'click', 'scroll'];
    events.forEach(event => {
        document.addEventListener(event, resetTimer, false);
    });

    resetTimer();
}

/**
 * Gets the button element from either an event object or direct element reference.
 * Handles cases where the click event might be on a span within the button.
 * 
 * @param {Event|Element} e - Either an Event object from click handler or direct element reference
 * @returns {jQuery} jQuery object representing the button element
 */
function getButtonElement(e) {
	let $button = e instanceof Event ? am.$(e.target) : am.$(e); 
	return $button.is('span') ? $button.parent() : $button;
}

function generateUniqueId() {
    const date = new Date();
    const uniqueId = date.getFullYear() + (date.getMonth() + 1).toString().padStart(2, '0') +date.getDate().toString().padStart(2, '0') + date.getHours().toString().padStart(2, '0') + date.getMinutes().toString().padStart(2, '0') + date.getSeconds().toString().padStart(2, '0') + date.getMilliseconds().toString().padStart(3, '0');
    return uniqueId;
}

function formatDateByDisplayOptions(dateString, options=false) {
	if(!options)
		options = { year: 'numeric', month: 'short', day: 'numeric' };
	var date = new Date(dateString);

	return date.toLocaleDateString(navigator.language, options);
}

function checkPopupsEnabled() {
    const testPopup = window.open('', '', 'width=100,height=100');

    if (testPopup) {
        testPopup.close();
        return true;
    } else {
        return false;
    }
}

/**
 * Toggles a textarea between collapsed and expanded states.
 * If collapsed, expands to fit content. If expanded, collapses to original height.
 * 
 * @param {HTMLElement} textarea - The textarea element to toggle
 */
function toggle_textarea(textarea) {
	var $textarea = am.$(textarea);
	
	// Get the original collapsed height from data attribute or from the original style
	var collapsedHeight = $textarea.data('collapsed-height');
	if (!collapsedHeight) {
		// Get from inline style or computed height
		var originalHeight = $textarea.css('height');
		if (originalHeight && originalHeight !== 'auto') {
			collapsedHeight = parseInt(originalHeight);
		} else {
			collapsedHeight = parseInt($textarea.height()) || 50;
		}
		// Store it for future use
		$textarea.data('collapsed-height', collapsedHeight);
	}
	
	var currentHeight = parseInt($textarea.height());
	
	// Check if currently expanded (height is significantly greater than collapsed height)
	// Using 10px buffer to account for rounding/measurement differences
	var isExpanded = currentHeight > (collapsedHeight + 10);
	
	if (isExpanded) {
		// Collapse back to original height
		$textarea.css('height', collapsedHeight + 'px');
		$textarea.attr('title', 'Click to expand');
	} else {
		// Expand to fit content
		$textarea.css('height', 'auto');
		var expandedHeight = textarea.scrollHeight;
		$textarea.css('height', expandedHeight + 'px');
		$textarea.attr('title', 'Click to collapse');
	}
}
function get_locale_by_currency(currency = false, cur_abbr='user'){
	if(!currency)
		currency = get_currency_symbol(cur_abbr);

	const currencyLocaleMap = {
		AUD: 'en-AU', BRL: 'pt-BR', CAD: 'en-CA', COP: 'es-CO',
		EUR: 'en-IE', // V1 This formats like USD with EUR for now.
		GBP: 'en-GB', MXN: 'es-MX', USD: 'en-US', XCD: 'en-AG'
	};
	var currencyLocale = currencyLocaleMap[currency] || 'en-US';

	// This will be a V2 but will take a sitewide format overhaul to add this granularity
	// €1,234.56, 1.234,56 €, 1 234,56 €
	// EUR: { 'de': 'de-DE', 'fr': 'fr-FR', 'es': 'es-ES', 'it': 'it-IT', 'nl': 'nl-NL', 'pt': 'pt-PT'}, // This will be a V2
	// if(typeof currencyLocale === 'object'){
	// 	// var subset = 'currency_format';
	// 	// currencyLocale = currencyLocale[subset];
	// }

	return currencyLocale;
}

function format_currency(number){
	const currency = get_currency_abbr('io');
	var currencyLocale = get_locale_by_currency(currency, 'io');

	return number.toLocaleString(currencyLocale, { minimumFractionDigits: 2, style: 'currency', currency });
}

/**
 * Format a number with commas and optional decimal precision.
 * Moved here from inventory.js so it's available in all bundles
 * (livetable.js uses it in tableUpdateSuccess).
 */
function precision(o,pow){
	var val = Math.pow(10, pow || 0);
	o = (parseInt(Math.round(o*val))/val).toString();
	if(o.match(/\..+/)){
		while(o.match(/\..+/).pop().length<=pow){
			o+='0';
		}
	} else if(pow > 0){
		o+='.';
		while(pow-- > 0){
			o+='0';
		}
	}
	return o;
}
function number_format(num,prec){
	if(typeof(num)=='string') num = num.replace(',', '', 'g');
	if(prec !== null && prec !== undefined) num = precision(num,prec);
	var arr = num.toString().split('.');
	var whole = arr[0];
	var frac = arr[1];
	whole = parseInt(whole) || 0;
	whole += ' ';
	var old;
	while(old != whole){
		old = whole;
		whole = whole.replace(/(\d)(\d{3})(\D)/g,'$1,$2$3');
	};
	whole = whole.replace(/\ $/,'');
	if(num < 0 && whole == 0) whole = '-0';
	return whole+(frac?'.'+frac:'');
}

/**
 * Returns current user info from hidden DOM inputs.
 * Moved here from orders.js so it's available in all bundles
 * (js-settings, js-reports, etc.) without loading the full orders script.
 */
function get_user_info() {
	var typeEl = document.getElementById("user-type");
	var idEl = document.getElementById("user-id");
	var tzEl = document.getElementById("user-timezone");
	var type = (typeEl && typeEl.value) ? typeEl.value : "customer";
	var id = idEl ? idEl.value : "";
	var timezone = tzEl ? tzEl.value : "";
	var is_logged = id !== "";
	var is_admin = parseInt(id) === 1;
	return { type: type, id: id, is_logged: is_logged, timezone: timezone, is_admin: is_admin };
}

